import Vue from 'vue'
import Component from 'vue-class-component'
import AddButton from '../buttons/AddButton.vue'
import convoStore from '../../store/convo/convo-store'
import { IStatement } from '../../model/statement'

@Component({
  name: 'statementAdd',
  props: ['statement'],
  components: { 'add-button' : AddButton },
})
export default class StatementAdd extends Vue {

  protected addFormStatement(statement: IStatement): void {
    convoStore.dispatchAddFormStatement(this.$props['statement'])
  }

}
